import React from 'react';
import InvoiceDetailRouter from '../domains/billing/components/InvoiceDetailRouter';

const AdminInvoice: React.FC = () => {
  return <InvoiceDetailRouter />;
};

export default AdminInvoice;
